import { Icons, colors } from '@pdcfrontendui/components';
import { deviceType, primaryInput } from 'detect-it';
import { currentLanguage } from '../currentLanguage';
import { EmptyState, EmptyStateSize } from '@pdcplan/shared/components';

function NoPersonGroupFollowedImage() {
  return (
    <svg
      viewBox="0 0 221 203"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <title>FollowNoPersonelGroup</title>
      <g
        id="FollowNoPersonelGroup"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g transform="translate(0.2171, 0)">
          <rect x="10.8042341" y="0" width="203" height="203"></rect>
          <path
            d="M165.232813,53.1031197 C183.922128,63.2129398 206.985537,68.0851422 210.69689,79.656623 C214.408244,91.3499089 198.767541,109.986083 193.067963,128.256842 C187.368384,146.527602 191.742479,164.432946 184.452321,174.177351 C177.162163,184.043561 158.207752,185.870636 142.434501,184.043561 C126.661249,182.33829 113.93661,177.100672 95.114747,177.953307 C76.4254325,178.684138 51.6388949,185.505221 34.2750637,179.536773 C17.0437809,173.568325 7.10265613,154.688541 10.4163644,137.635832 C13.7300726,120.704929 30.2986138,105.357491 38.7817069,86.2340964 C47.3973483,67.1107017 48.06009,44.0895452 59.8568913,31.0564036 C71.6536927,18.023262 94.717102,14.8563304 113.406417,21.0683886 C132.095731,27.2804467 146.410951,42.8714945 165.232813,53.1031197 Z"
            fill={colors.colorPrimaryLightest}
            fillRule="nonzero"
            transform="translate(110.5214, 101.3361) rotate(-7.3085) translate(-110.5214, -101.3361)"
          ></path>
          <circle
            fill={colors.colorPrimaryUltraLightest}
            cx="127.782873"
            cy="102"
            r="20"
          ></circle>
          <g
            transform="translate(58.8982, 52.1283)"
            fill={colors.colorPrimaryDark}
            fillRule="nonzero"
          >
            <path d="M99.3737803,82.0328342 C95.8813376,78.5375717 91.8005352,75.6847885 87.3184069,73.6052352 C93.6391062,68.4844921 97.6715169,60.6708242 97.6715169,51.9083537 C97.6715169,36.4484536 84.7789649,23.7651962 69.3190647,24.0023968 C54.0963653,24.2395974 41.8316972,36.6437953 41.8316972,51.9083537 C41.8316972,60.6708242 45.878061,68.4844921 52.1848072,73.6052352 C47.7018033,75.6832668 43.6207482,78.5362267 40.1294338,82.0328342 C32.5111076,89.6651134 28.1856843,99.7391638 27.9062754,110.482957 C27.8991011,110.783807 28.0133746,111.074949 28.2235309,111.290359 C28.4336872,111.505769 28.7219191,111.627101 29.022863,111.627101 L36.8365309,111.627101 C37.436509,111.627101 37.9388162,111.1527 37.9527692,110.552722 C38.2178758,102.459995 41.4968257,94.8835273 47.2594058,89.1349002 C53.2156285,83.1470101 61.3198,79.7907878 69.7655601,79.8143106 C78.2629239,79.8143106 86.2579806,83.1211665 92.2717143,89.1349002 C98.0203414,94.8835273 101.299291,102.459995 101.578351,110.552722 C101.592304,111.1527 102.094611,111.627101 102.694589,111.627101 L110.508257,111.627101 C110.809201,111.627101 111.097433,111.505769 111.307589,111.290359 C111.517745,111.074949 111.632019,110.783807 111.624845,110.482957 C111.345436,99.7391638 107.020012,89.6651134 99.3737803,82.0328342 Z M69.7655601,69.7682415 C64.9936414,69.7682415 60.5007824,67.91242 57.1381146,64.5357992 C53.7283792,61.1529327 51.839781,56.5296444 51.9057476,51.726965 C51.9476066,47.150388 53.7754468,42.7272939 56.9706788,39.4483439 C60.3193936,36.0159112 64.7982997,34.1043532 69.5841713,34.0485413 C74.314231,34.0066824 78.9047609,35.8484755 82.2813817,39.1553314 C85.7417204,42.5459052 87.6393254,47.0806232 87.6393254,51.9083537 C87.6393254,56.6802723 85.7835793,61.1591784 82.4069585,64.5357992 C79.0608606,67.8979179 74.5089789,69.7819749 69.7655601,69.7682415 L69.7655601,69.7682415 Z M34.8133491,55.59194 C34.6877723,54.3780309 34.6180074,53.1501688 34.6180074,51.9083537 C34.6180074,49.6898301 34.827302,47.5271185 35.2179854,45.4202187 C35.3156563,44.9179115 35.0505497,44.4016513 34.5901014,44.1923566 C32.6924963,43.3412249 30.948374,42.1691747 29.4414524,40.690159 C25.8511242,37.2089414 23.8912767,32.3776894 24.0416497,27.3790176 C24.1672265,22.9001115 25.9671607,18.6444531 29.1065809,15.435268 C32.5529665,11.9051645 37.1853554,9.97965348 42.1107568,10.0354654 C46.5617569,10.0773243 50.8592743,11.7935407 54.1103182,14.83529 C55.2126035,15.8678104 56.1614061,17.0119546 56.9567258,18.2398167 C57.2357854,18.672359 57.7799516,18.8537478 58.2543528,18.686312 C60.710077,17.8351803 63.305331,17.2352023 65.9703499,16.9561427 C66.7517167,16.8724248 67.198212,16.0352461 66.8493876,15.3375972 C62.3146696,6.36583206 53.0498919,0.170709632 42.3340044,0.00327389065 C26.8601513,-0.233926743 13.9675993,12.4493307 13.9675993,27.8952778 C13.9675993,36.6577483 18.00001,44.4714162 24.3207093,49.5921593 C19.8836621,51.6432471 15.7954394,54.4757017 12.2513829,58.0197583 C4.60515073,65.6520375 0.279727412,75.7260879 0.000318516683,86.4838343 C-0.006855768,86.7846841 0.107417747,87.0758259 0.317574031,87.2912361 C0.527730315,87.5066463 0.815962261,87.6279786 1.11690612,87.6279786 L8.94452702,87.6279786 C9.5445051,87.6279786 10.0468123,87.1535772 10.0607653,86.5535992 C10.3258719,78.4608717 13.6048218,70.8844044 19.3674019,65.1357773 C23.4695776,61.0336016 28.4926498,58.187194 33.9761704,56.8058491 C34.5203365,56.6663193 34.8831139,56.1500591 34.8133491,55.59194 L34.8133491,55.59194 Z"></path>
          </g>
          <circle
            fill={colors.colorPrimaryDark}
            cx="137.186375"
            cy="101.53648"
            r="3"
          ></circle>
          <circle
            fill={colors.colorPrimaryDark}
            cx="126.186375"
            cy="101.53648"
            r="3"
          ></circle>
          <circle
            fill={colors.colorPrimaryDark}
            cx="101.811375"
            cy="77.5364796"
            r="3"
          ></circle>
          <circle
            fill={colors.colorPrimaryDark}
            cx="90.8113753"
            cy="77.5364796"
            r="3"
          ></circle>
        </g>
      </g>
    </svg>
  );
}

const NoPersonGroupFollowed = () => {
  const useTouch = deviceType === 'touchOnly' || primaryInput === 'touch';
  return (
    <EmptyState
      image={NoPersonGroupFollowedImage}
      heading={currentLanguage.NoPersonelGroupFollowedTitle}
      description={
        <div>
          {useTouch
            ? currentLanguage.NoPersonelGroupFollowedTextMobile
            : currentLanguage.NoPersonelGroupFollowedTextWeb}
          {useTouch && (
            <Icons.Follow
              style={{ marginLeft: '4px', display: 'inline-block' }}
            />
          )}
        </div>
      }
      size={EmptyStateSize.Small}
    />
  );
};

export default NoPersonGroupFollowed;
